import { Clerk } from "@clerk/clerk-js";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

// Create a singleton instance of Clerk
export const clerk = new Clerk(PUBLISHABLE_KEY);

// Helper function to get the current session token.
//
// There are TWO Clerk instances on the page: this standalone one, and whichever
// one Clerk itself publishes on window.Clerk. They are supposed to be the same
// session, and usually are — but the standalone instance can be sitting there
// with `session === undefined` while window.Clerk has a live, active session
// and hands out a perfectly good token. When that happens every request goes
// out with NO Authorization header, the API answers 401, and every screen shows
// its own error state at once. It looks exactly like the backend is down.
//
// So: ask this instance first, and fall back to whichever one actually has a
// session. Never return nothing while a valid token exists on the page.
export const getSessionToken = async () => {
  try {
    const token = await clerk.session?.getToken();
    if (token) return token;
  } catch (error) {
    console.error("Error getting session token:", error);
  }

  try {
    const fallback = await window.Clerk?.session?.getToken();
    if (fallback) return fallback;
  } catch (error) {
    console.error("Error getting session token from window.Clerk:", error);
  }

  return null;
};

// Helper function to check if user is authenticated
export const isAuthenticated = () => {
  return !!clerk.session;
};
